import React from 'react';
import { useTranslation } from 'react-i18next';

import { NSPP_PATIENT } from '../../../../../../../services/i18n/namespaces';
import { usePatientProfile } from '../../PatientProfileContext';

export default function PatientDetailsFinancialInformation() {
  const { t } = useTranslation(NSPP_PATIENT);
  const { patientInfo } = usePatientProfile();
  const { ssn, cardInfo } = patientInfo || {};
  return (
    <div className="patient-profile-information-content-section">
      <div className="patient-profile-information-header">
        <div className="patient-profile-information-header-title">{t('profile.patientFinancial')}</div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('ssn')}:`}</div>
          <div className="patient-profile-information-label-field">{ssn?.toUpperCase() || '-'}</div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('info.pid')}:`}</div>
          <div className="patient-profile-information-label-field">{cardInfo?.id || '-'}</div>
        </div>
      </div>
    </div>
  );
}
